module.exports = __webpack_public_path__ + "img/pr-8.462f298a.png";